module.exports = __webpack_public_path__ + "img/polygon-1.f9c8725c.svg";